import { createAction } from 'redux-starter-kit';
import { get } from '../../../../utility/via-fetch';
import { requestStart, requestSucceded, requestFailed } from '../../../domain/requests/RequestActions';
import {putCurrencyReports, putTaxReportRegions} from '../../../domain/financial/financialActions';

/**
 * Actions to request loading
 */
export const loadCurrencyReports = createAction('LOAD_CURRENCY_REPORTS');
export const loadTaxReportRegions = createAction('LOAD_TAX_REPORT_REGIONS');

/**
 * A action that retrieves reports by currency
 * @param {string} locale The unique identifier of teh current app language E.G es_MX
 */
export function requestLoadCurrencyReports(fromDate, toDate) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(loadCurrencyReports.toString()));
    dispatch(loadCurrencyReports({ requestId }));
    try {
      const reports = await get('/api/tokens/purchase/monthly-report', { fromDate, toDate }, { });
      dispatch(putCurrencyReports(reports));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId)); // We failed.
    }
  };
}

/**
 * A action that retrieves tax report regions
 * @param {string} locale The unique identifier of teh current app language E.G es_MX
 */
export function requestLoadTaxReportRegions(fromDate, toDate) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(loadTaxReportRegions.toString()));
    dispatch(loadTaxReportRegions({ requestId }));
    try {
      const reports = await get('/api/tokens/purchase/monthly-tax-report', { fromDate, toDate }, { });
      dispatch(putTaxReportRegions(reports));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId)); // We failed.
    }
  };
}

